export const breakpoints = {
  mobile: 480,
  tablet: 768,
  smallDesktop: 1024,
  largeDesktop: 1200,
}

export const colors = {
  primary: '#00274c',
  white: '#fafafa',
  white2: '#fff',
  black: '#373435',
  gray: '#808080',
  gray2: '#e8e8e8',
}
